import { GraphQLClient } from 'graphql-request';
import { filter, map, get } from 'lodash';
import { defaultEndpoint } from './consts';

export function Client({ endpoint = defaultEndpoint, token } = {}) {
  const client = new GraphQLClient(endpoint, {
    credentials: 'include',
    mode: 'cors',
    ...(token ? {
      headers: {
        authorization: `Bearer ${token}`,
      },
    } : null),
  });
  this.request = async (query, variables = {}) => {
    try {
      const result = await client.request(query, variables);
      return result;
    } catch (e) {
      if (e.response) {
        throw new Error(filter(map(get(e.response, 'errors'), 'message')).join(' '));
      } else if (e instanceof Error) {
        throw e;
      } else if (e instanceof String) {
        throw new Error(e);
      }
    }
    return null;
  };
}
